import Vue from "vue";
import Router from "vue-router";
import Homepage from "./Homepage.vue";

// The homepage is in the main bundle: Googlebot renders the page with a small resource
// budget, and a lazy homepage left it with an empty <div id="app"> (Nov 2026). Every other
// view is its own chunk, named here so webpack does not build a chunk for every .vue file.
const views = {
  Capture: () => import(/* webpackChunkName: "view-Capture" */ "./Capture.vue"),
  Team: () => import(/* webpackChunkName: "view-Team" */ "./Team.vue"),
  WhyItWorks: () => import(/* webpackChunkName: "view-WhyItWorks" */ "./WhyItWorks.vue"),
  Affiliate: () => import(/* webpackChunkName: "view-Affiliate" */ "./Affiliate.vue"),
  ResetPassword: () => import(/* webpackChunkName: "view-ResetPassword" */ "./ResetPassword.vue"),
  Disclaimer: () => import(/* webpackChunkName: "view-Disclaimer" */ "./Disclaimer.vue"),
  Signup: () => import(/* webpackChunkName: "view-Signup" */ "./Signup.vue"),
  SignupForm: () => import(/* webpackChunkName: "view-SignupForm" */ "./SignupForm.vue"),
  Performance: () => import(/* webpackChunkName: "view-Performance" */ "./Performance.vue"),
  Account: () => import(/* webpackChunkName: "view-Account" */ "./Account.vue"),
  Slip: () => import(/* webpackChunkName: "view-Slip" */ "./Slip.vue"),
  Slips: () => import(/* webpackChunkName: "view-Slips" */ "./Slips.vue"),
};

function loadView(view) {
  return view === "Homepage" ? Homepage : views[view];
}

Vue.use(Router);

const router = new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
      //Or for Vue 3:
      //return {el: to.hash}
    } else {
      if (to.name == "Signup form" && from.name == "Signup form") {
        return;
      }
      if (savedPosition && savedPosition.y) {
        return window.scrollTo({
          top: savedPosition.offsetTop,
          behavior: "smooth",
        });
      } else {
        if (window.donotscroll) {
          window.donotscroll = false;
          return;
        }
        return window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  },
  routes: [
    {
      path: "/",
      name: "Homepage",
      component: loadView("Homepage"),
    },
    {
      path: "/predictions",
      name: "Predictions",
      component: loadView("Homepage"),
    },
    {
      // daily-video capture (services/videos); not linked from the site
      path: "/capture",
      name: "Capture",
      component: loadView("Capture"),
    },
    {
      path: "/socials",
      name: "Homepage",
      component: loadView("Homepage"),
    },
    {
      path: "/teams/:slug",
      name: "Team",
      component: loadView("Team"),
    },
    {
      path: "/why",
      name: "WhyItWorks",
      component: loadView("WhyItWorks"),
    },
    {
      path: "/refer",
      name: "Affiliate",
      component: loadView("Affiliate"),
    },
    {
      path: "/reset",
      name: "ResetPassword",
      component: loadView("ResetPassword"),
    },
    {
      path: "/disclaimer",
      name: "Disclaimer",
      component: loadView("Disclaimer"),
    },
    {
      path: "/signup",
      name: "Signup",
      component: loadView("Signup"),
    },
    {
      path: "/signup/:type",
      name: "Signup form",
      component: loadView("SignupForm"),
    },
    {
      path: "/performance",
      name: "Performance",
      component: loadView("Performance"),
    },
    {
      path: "/account",
      name: "Account",
      component: loadView("Account"),
    },
    {
      path: "/slip",
      name: "Slip",
      component: loadView("Slip"),
    },
    {
      path: "/slip/:id",
      name: "SharedSlip",
      component: loadView("Slip"),
    },
    {
      path: "/slips",
      name: "Slips",
      component: loadView("Slips"),
    },
  ],
});

export default router;
